// import React from "react";
// import { useNavigate } from "react-router-dom";
// import "./CampusCss/SawaiChotiCampus.css"; // Ensure this CSS file is linked

// const SawaiChotiCampus = () => {

// const navigate = useNavigate();

//   return (
//     <div className="sawai-choti-container">

//       {/* Hero Section */}
//       <section className="hero">
//         <div className="hero__content">
//           <h1 className="hero__title"> Shri Kheteshwar Gurukul, Sawai Choti</h1>
//           <p className="hero__description">
//             With the divine inspiration of <strong>Pujya Sadgurudev Ji</strong> and the guidance of{" "}
//             <strong>Pujya Vedantacharya Ji</strong>, <strong>Shri Kheteshwar Gurukul</strong> was inaugurated in{" "}
//             <strong>July 2024</strong> in <strong>Sawai Choti, Tehsil Sardarshahar, District Churu</strong>.
//           </p>
//         </div>
//       </section>

//       {/* About Section */}
//       <section className="about">
//       <img src="/sawaichotiadmission.jpg" alt="Sawai Choti Gurukul" className="about__image" />
//         <div className="about__content">
//           <h2 className="about__title">🌿 About the Gurukul</h2>
//           <p className="about__description">
//             This Gurukul currently offers education up to the <strong>5th grade</strong> and admits both{" "}
//             <strong>boys (Rishikumars) and girls (Rishikanyas)</strong>. Presently,{" "}
//             <strong>30 Rishikumars and Rishikanyas</strong> are receiving <strong>Vedic and practical education</strong>{" "}
//             under the guidance of <strong>three dedicated Acharyas</strong>.
//           </p>
//         </div>
        
//       </section>

//       {/* Education System */}
//       <section className="education">
//         <h2 className="education__title">📖 Our Education System</h2>
//         <div className="education__cards">
//           <div className="education__card">
//             <img src="/sawai3.jpeg" alt="Vedic Education" className="education__card-image" />
//             <h3 className="education__card-title">Vedic Education</h3>
//             <p className="education__card-description">
//               Students learn the <strong>Vedas, Shastras, and Upanishads</strong> through traditional methods, preserving
//               ancient wisdom.
//             </p>
//           </div>
//           <div className="education__card">
//             <img src="/sawai4.jpeg" alt="Practical Education" className="education__card-image" />
//             <h3 className="education__card-title">Practical Education</h3>
//             <p className="education__card-description">
//               Alongside Vedic studies, students are taught <strong>modern subjects</strong> to prepare them for
//               contemporary challenges.
//             </p>
//           </div>
//           <div className="education__card">
//             <img src="/sawai2.jpeg" alt="Dedicated Acharyas" className="education__card-image" />
//             <h3 className="education__card-title">Dedicated Acharyas</h3>
//             <p className="education__card-description">
//               Three <strong>Acharyas</strong> work tirelessly to provide <strong>personalized guidance</strong> and
//               ensure holistic development.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* Photo Gallery */}
//       <section className="gallery">
//         <h2 className="gallery__title">📸 Photo Gallery</h2>
//         <div className="gallery__grid">
//           <img src="/sawaichotiadmission.jpg" alt="Gallery 1" className="gallery__image" />
//           <img src="/sawai2.jpeg" alt="Gallery 2" className="gallery__image" />
//           <img src="/sawai3.jpeg" alt="Gallery 3" className="gallery__image" />
//           <img src="/sawai4.jpeg" alt="Gallery 4" className="gallery__image" />
//           <img src="/sawai5.jpeg" alt="Gallery 5" className="gallery__image" />
//         </div>
//       </section>

//       {/* Footer */}
//       <footer className="footer">
//         <p className="footer__text">📍 Located in Sawai Choti, Tehsil Sardarshahar, District Churu</p>
//         <p className="footer__text">📜 <em>Nurturing the future through Vedic and modern education</em></p>
//       </footer>
//     </div>
//   );
// };

// export default SawaiChotiCampus;



import React from "react";
import "./CampusCss/SawaiChotiCampus.css";

const SawaiChotiCampus = () => {
  return (
    <div className="gurukul-containerCS">

      {/* Header Section */}
      <header className="headerCS">
        <div className="header-contentCS">
          <h1>Shri Kheteshwar Gurukul</h1>
          <h2>Choti Sawai, Churu, Rajasthan</h2>
          <div className="header-decorationCS"></div>
        </div>
      </header>

      {/* Introduction */}
      <section className="introCS">
        <div className="intro-contentCS">
          <div className="intro-textCS">
            <h2>Our Newest Gurukul Branch</h2>
            <p>
              Established in <strong>2024-25</strong>, this Gurukul is the newest addition to our family. 
              Starting with <strong>30 students</strong>, we follow the same unique class system from <strong>"Arun Class" to "Panchami Class"</strong> 
              and are affiliated with the <strong>Rajasthan Board of Secondary Education</strong>.
            </p>
            <div className="progress-containerCS">
              <h4>Current Development Status</h4>
              <div className="progress-barCS">
                <div className="progress-fillCS" style={{ width: '65%' }}>65%</div>
              </div>
              <p>Permanent infrastructure completion</p>
            </div>
          </div>
          <img src="/sawai3.jpeg" alt="Choti Sawai Gurukul" className="main-imageCS" />
        </div>
      </section>

      {/* Growth Timeline */}
      <section className="growthCS">
        <div className="section-headerCS">
          <h2>📈 Our Growth Journey</h2>
          <p className="section-subtitleCS">From foundation to future</p>
        </div>
        <div className="milestonesCS">
          <div className="milestoneCS">
            <div className="milestone-dateCS">2024</div>
            <div className="milestone-contentCS">
              <h3>Foundation Year</h3>
              <p>Started with 30 students in rented premises</p>
            </div>
          </div>
          {/* <div className="milestoneCS">
            <div className="milestone-dateCS">2025</div>
            <div className="milestone-contentCS">
              <h3>Land Acquisition</h3>
              <p>Purchased 2 acres for permanent campus</p>
            </div>
          </div>
          <div className="milestoneCS">
            <div className="milestone-dateCS">2026</div>
            <div className="milestone-contentCS">
              <h3>Phase 1 Construction</h3>
              <p>First 4 classrooms completed</p>
            </div>
          </div> */}
        </div>
      </section>

      {/* Current Stats */}
      <section className="current-statsCS">
        <div className="stats-gridCS">
          <div className="stat-cardCS">
            <div className="stat-numberCS">30</div>
            <div className="stat-labelCS">Current Students</div>
          </div>
          <div className="stat-cardCS">
            <div className="stat-numberCS">5</div>
            <div className="stat-labelCS">Class Levels</div>
          </div>
          <div className="stat-cardCS">
            <div className="stat-numberCS">3</div>
            <div className="stat-labelCS">Teaching Staff</div>
          </div>
          <div className="stat-cardCS">
            <div className="stat-numberCS">100%</div>
            <div className="stat-labelCS">RBSE Affiliated</div>
          </div>
        </div>
      </section>

      {/* Future Plans */}
      <section className="futureCS">
        <div className="section-headerCS">
          <h2>🔮 Vision for the Future</h2>
        </div>
        <div className="vision-cardsCS">
          <div className="vision-cardCS">
            <h3>2026 Expansion</h3>
            <ul>
              {/* <li>Complete first phase construction</li> */}
              <li>Increase capacity to 100 students</li>
            </ul>
          </div>
          <div className="vision-cardCS">
            <h3>2028 Goals</h3>
            <ul>
              <li>Full permanent campus</li>
              <li>Smart classrooms</li>
              <li>Sports facilities</li>
            </ul>
          </div>
          <div className="vision-cardCS">
            <h3>2030 Vision</h3>
            <ul>
              <li>300+ students</li>
              <li>Vocational training center</li>
              <li>Community outreach programs</li>
            </ul>
          </div>
        </div>
      </section>


       {/* Photo Gallery */}
       <section className="gallery">
         <h2 className="gallery__title">Photo Gallery</h2>
         <div className="gallery__grid">
           <img src="/sawaichotiadmission.jpg" alt="Gallery 1" className="gallery__image" />
           <img src="/sawai2.jpeg" alt="Gallery 2" className="gallery__image" />
           <img src="/sawai3.jpeg" alt="Gallery 3" className="gallery__image" />
           <img src="/sawai4.jpeg" alt="Gallery 4" className="gallery__image" />
           <img src="/sawai5.jpeg" alt="Gallery 5" className="gallery__image" />
         </div>
       </section>

    </div>
  );
};

export default SawaiChotiCampus;